import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLBoolean,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList
} from 'graphql';
import { toGlobalId } from 'graphql-relay';

import UserType from './user.gql';
import QuestionFeedbackType from './questionFeedback.gql';
import { SubmissionAnswerEnum } from './transformToEnums/SubmissionAnswerEnum';

const questionResponseType = new GraphQLObjectType({
  name: 'QuestionResponse',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: item => toGlobalId('QuestionResponse', item._id)
    },
    pid: {
      type: GraphQLString,
      resolve: item => item._id
    },
    evaluatedAnswer: {
      type: GraphQLString,
      resolve: item => item.answerEvaluation || ''
    },
    response: {
      type: GraphQLString,
      resolve: item => item.response || ''
    },
    thumbUrl: {
      type: GraphQLString,
      resolve: root => root.thumbnail || ''
    },
    text: {
      type: GraphQLString,
      resolve: root => (root.speechToText ? root.speechToText.text : '')
    },
    confidence: {
      type: GraphQLString,
      resolve: root => (root.speechToText && root.speechToText.confidence
        ? root.speechToText.confidence.toString()
        : '')
    },
    dirtyResponse: {
      type: GraphQLBoolean,
      resolve: () => false
    },
    lastUpdatedResponse: {
      type: GraphQLString,
      resolve: root => root.submittedOn
    },
    answerType: {
      type: GraphQLString,
      resolve: root => (root.responseType ? SubmissionAnswerEnum[root.responseType] : SubmissionAnswerEnum[''])
    },
    feedback: {
      type: GraphQLString,
      resolve: root => (root.feedback ? root.feedback : '')
    },
    feedbacks: {
      type: new GraphQLList(QuestionFeedbackType),
      resolve: (root) => {
        const stateInteractions = root.stateInteractions || [];
        const filteredInterection = stateInteractions.filter(
          interection => interection.submissionId === root._id && interection.interactionType === 'feedback'
        );
        const feedbacksList = filteredInterection.map(feedback => ({
          _id: feedback.contentId_interactionType_interactingOnId_actorId,
          feedback: feedback.feedbackText,
          feedbackGivenBy: {
            id: toGlobalId('User', feedback.actorId.toString()),
            pid: feedback.actorId,
            actorType: feedback.actorType
          }
        }));
        return feedbacksList;
      }
    },
    feedbackGivenBy: {
      type: UserType,
      resolve: root => ({
        id: '12345',
        pid: '1234'
      })
    },
    gradedBy: {
      type: UserType,
      resolve: (root) => {
        const stateInteractions = root.stateInteractions || [];
        const filteredInterection = stateInteractions.filter(
          interection => interection.submissionId === root._id && interection.interactionType === 'grade'
        );
        filteredInterection.sort((a, b) => (a.updatedAt < b.updatedAt ? -1 : a.updatedAt > b.updatedAt ? 1 : 0)
        );
        const lastInterection = filteredInterection[filteredInterection.length - 1];
        const userID = (lastInterection && lastInterection.actorId) || '';
        return {
          id: toGlobalId('User', userID.toString()),
          pid: userID
        };
      }
    }
  })
});

window[questionResponseType.name + 'GQLType'] = questionResponseType;

export default questionResponseType;
